import { SelectMenu } from '@scale/scaleui';
import { useChatStoreExtract } from 'react-scale/components/scalers/tasks/Chat/hooks/ChatStore.hooks';
import { MessageRole } from '@scale/shared/types/chat';
import _ from 'lodash';

interface Props {
  role?: MessageRole;
  setRole?: (role: MessageRole) => void;
}

const MessageRoleSelect = ({ role, setRole }: Props) => {
  const config = useChatStoreExtract(state => state.config);

  return (
    <SelectMenu
      label="Message Role"
      options={(config.messageRoleOptions || []).map(roleOption => ({
        id: roleOption,
        name: _.capitalize(roleOption),
      }))}
      selectedOptionId={role || ''}
      setSelected={chosenRole => {
        setRole?.(chosenRole || MessageRole.User);
      }}
      helperText={config.messageRolePromptInputHint}
    />
  );
};

export default MessageRoleSelect;
